import React, { FunctionComponent } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { useLoaderConfig } from '@components/Loader/useLoaderConfig';
import { BrandLoader } from '@components/Loader/BrandLoader';
import { LoaderProgress } from '@components/Loader/LoaderProgress';
import vendorLogo from '@assets/crash/logo-vendor.svg';

const LoaderWrapper = styled.div<{ background: string }>`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 120;
    background: ${({ background }) => background};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5rem;
`;

const LoaderContent = styled.div`
    width: 100%;
    max-width: ${__WHITELABEL__ ? 355 : 500}px;
    z-index: 120;
    margin: auto;
`;

const flash = keyframes`
    from {
        filter: drop-shadow(0 0px 40px rgba(255, 255, 255, 0.4));
    }

    50% {
        filter: drop-shadow(0 0px 70px rgba(255, 255, 255, 0.4));
    }

    to {
        filter: drop-shadow(0 0px 40px rgba(255, 255, 255, 0.4));
    }
`;

const LoaderLogo = styled.img`
    width: 100%;
    animation: ${css`
        ${flash} 1.5s linear infinite
    `};
`;

export const Loader: FunctionComponent<{ logo: { background?: string; logo: string } }> = ({ logo }) => {
    const themeConfig = useLoaderConfig(window.env.REACT_APP_ASSETS_ENDPOINT);

    if (themeConfig) return <BrandLoader config={themeConfig} />;

    return (
        <LoaderWrapper background={logo.background ?? '#000'}>
            <LoaderContent>
                {logo && <LoaderLogo src={logo.logo || vendorLogo} alt="logo" />}
                <LoaderProgress />
            </LoaderContent>
        </LoaderWrapper>
    );
};
